import type { CampaignCopyDto } from "src/app/features/Campaign/types/CampaignCopyDto";
import type { CampaignCopyEntity } from "src/app/features/Campaign/types/CampaignCopyEntity";

export const CampaignCopyEntityToCopyDto = (campaignCopyEntity: CampaignCopyEntity): CampaignCopyDto => {
    return { ...campaignCopyEntity };
};
